import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const bookingsLastNameViewer = {
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map